export const PLACEHOLDER_IMAGE =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='300' height='300' viewBox='0 0 300 300'%3E%3Crect width='300' height='300' fill='%23f0f0f0'/%3E%3Ctext x='50%25' y='45%25' font-family='Arial' font-size='48' fill='%23ddd' text-anchor='middle' dy='.3em'%3E📦%3C/text%3E%3Ctext x='50%25' y='60%25' font-family='Arial' font-size='14' fill='%23999' text-anchor='middle' dy='.3em'%3ENo Image%3C/text%3E%3C/svg%3E";

export const sanitizeImageUrl = (rawUrl) => {
  if (!rawUrl || typeof rawUrl !== "string") return null;

  let url = rawUrl.trim();
  if (!url) return null;

  url = url.replace(/^b['"]|['"]$/g, "").replace(/\s+/g, "");

  if (!url) return null;

  if (url.startsWith("data:image")) {
    const commaIndex = url.indexOf(",");
    if (commaIndex === -1) return null;

    const header = url.slice(0, commaIndex);
    const payload = url.slice(commaIndex + 1);

    if (!payload) return null;

    if (header.includes(";base64")) {
      const base64 = payload.replace(/\s+/g, "");
      if (!/^[A-Za-z0-9+/]*={0,2}$/.test(base64) || base64.length % 4 !== 0) {
        return null;
      }
    }

    return `${header},${payload}`;
  }

  if (
    url.startsWith("http://") ||
    url.startsWith("https://") ||
    url.startsWith("/uploads/") ||
    url.startsWith("uploads/") ||
    url.startsWith("blob:") ||
    url.startsWith("data:")
  ) {
    return url;
  }

  return url;
};
